/**
 * Search Modal
 * @author: BenJ
 */
$(document).ready(function() {

    $('#modal-search').on('shown.bs.modal', function (e) {
        // Remove focus from button
        var button = $(e.relatedTarget);
        button.one('focus', function () {
            $(this).blur();
        });

        $('#input-search', this).focus();
    })
});
